import React from 'react';
import { RuleDetails } from 'Source/graphql/fragments/RuleDetails.generated';
import { DetectionType } from 'Generated/schema';
import urls from 'Source/urls';
import { Link } from 'pounceV2';
import { Link as RRLink } from 'react-router-dom';
import { CorrelationRule } from 'Source/graphql/fragments/CorrelationRule.generated';
import OverflowTextWithTooltipV3 from 'Components/OverflowTextWithTooltip/OverflowTextWithTooltipV3';
import { useTheme } from '@mui/material';

interface StepTitleProps {
  rule: RuleDetails | CorrelationRule;
  stepRuleID: string;
}

const StepTitleV3 = ({ rule, stepRuleID }: StepTitleProps) => {
  const {
    palette: { componentTokens },
  } = useTheme();
  const titleLink = React.useCallback(() => {
    if (
      rule?.analysisType === DetectionType.Rule ||
      rule?.analysisType === DetectionType.ScheduledRule
    ) {
      return urls.build.detections.rules.edit(rule?.id);
    }
    if (rule?.analysisType === DetectionType.CorrelationRule) {
      return urls.build.detections.correlationRules.edit(rule?.id);
    }
    return null;
  }, [rule?.analysisType, rule?.id]);

  if (rule) {
    return (
      <Link
        as={RRLink}
        to={titleLink()}
        size="medium"
        color={componentTokens.buttons.colors.link.primary.text.resting}
        external
      >
        <OverflowTextWithTooltipV3 numLines={2}>{rule.displayName}</OverflowTextWithTooltipV3>
      </Link>
    );
  }

  return <OverflowTextWithTooltipV3 numLines={2}>{stepRuleID}</OverflowTextWithTooltipV3>;
};

export default StepTitleV3;
